import { combineEpics } from 'redux-observable';

import appStartEpic from './appStart';
import changeLanguageEpic from './changeLanguage';

export default combineEpics(appStartEpic, changeLanguageEpic);
